import React from 'react';
import ContentLoader from 'react-content-loader';
import './SkeletonLoadingFirst3.css';
import '../css/cards/CardsBlogPortalOneOFThree.css';
import Skeleton from '@mui/material/Skeleton';

const SkeletonLoadingFirst3 = ({ elementNumber }) => {
  // const elementsArray =;
  return (
    <>
      {new Array(elementNumber).fill(
        <Skeleton className="movie-card image_looding" variant="rectangular" />
      )}
    </>
  );
};

export default SkeletonLoadingFirst3;
